<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>Would you like to provide any additional details?</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="details"
            outlined
            placeholder="Share anything that would help us improve..."
            rows="4"
          ></v-textarea>
          <v-radio-group v-model="puzzleDelivery">
            <v-radio label="Stop sending me puzzles" value="stop_immediately"></v-radio>
            <v-radio label="Send me puzzles until my subscription expires" value="until_expiry"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-text v-if="error">
          <span class="error--text">{{error}}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="goBack">Go back</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" class="white--text" :loading="loading" @click="submitCancel">Cancel subscription</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import subscriptionService from '../api/subscription-service';

export default {
  name: 'cancel_details',
  props: ['subscription_id'],
  data: function() {
    return {
      details: '',
      puzzleDelivery: 'stop_immediately',
      loading: false,
      error: null
    }
  },
  methods: {
    goBack: function() {
      this.$router.push({ name: 'cancel_subscription', params: { subscription_id: this.subscription_id } });
    },
    submitCancel: function() {
      const reason = this.$route.query.reason || 'not specified';
      const cancellationReason = this.details ? reason + ' - ' + this.details : reason;

      this.loading = true;
      this.error = null;

      subscriptionService.cancelSubscription(
        this.subscription_id,
        cancellationReason,
        this.puzzleDelivery,
        (data) => {
          this.loading = false;
          this.$store.commit('UPDATE_SUBSCRIPTION_CANCELLATION', {
            subscriptionId: this.subscription_id,
            canceledAt: data.canceled_at,
            membershipEndDate: data.membership_end_date
          });
          this.$router.push({ name: 'account', params: { subscription_id: this.subscription_id } });
        },
        () => {
          this.loading = false;
          this.error = 'Something went wrong. Please try again.';
        }
      );
    }
  }
}
</script>
